import ErrorMessage from 'components/common/ErrorMessage';
import { AuthLayout } from 'layouts/AuthLayout';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useNavigate, useNavigation } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { forgotPassword } from 'slices/userSlice';
import { userSelector } from 'slices/userSlice';
import { setError } from 'slices/userSlice';
import { login } from 'slices/userSlice';


const Footer = memo(() => (
    <div className='center_wrapper'>
        <p className="para3">Don’t have Interpreter Account? <Link to="/register">Let’s Create One!</Link></p>
    </div>
))

function ForgotPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { error, loader } = useSelector(userSelector)

    const [formValues, setFormValues] = useState({
        email: '',
    });
    const [sentTo, setSentTo] = useState('');

    const handleChange = useCallback((e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }, [formValues])

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className:"successToast",
            })
            // Do NOT jump to /reset-password — the reset link is emailed and carries the
            // token. Sending the user there directly left them on a tokenless form.
            setSentTo(formValues.email);
        }
        else {
             toast.error(message,
        {
          className:"errorToast",
        }
      );
        }
    };
    const resetAllErrors = () => {
        dispatch(setError({}))
    }
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        resetAllErrors()
        dispatch(forgotPassword(formValues, submitCallback))
    }, [formValues]);


    if (sentTo) {
        return (
            <AuthLayout
                heading="Check your email"
                title={<>We've sent a password reset link to <strong>{sentTo}</strong>. <br /><br />Open it to choose a new password — the link expires in one hour.<br /> If it hasn't arrived in a few minutes, please check your spam folder.</>}
                footer={<Footer />}
            >
                <div className='auth_form'>
                    <p className="para2">
                        <Link to="/login">
                            <i className="fa-solid fa-chevron-left me-2"></i>
                            {"Back to Login"}
                        </Link>
                    </p>
                    <button type="button" className="btn_auth" onClick={() => setSentTo('')}>
                        <span>Send to a different email</span>
                    </button>
                </div>
            </AuthLayout>
        )
    }

    return (
        <AuthLayout
            heading="Forgot Password"
            title="Dont worry, Enter your email address and we'll send you a password reset link."
            footer={<Footer />}
        >
            <form className='auth_form' action='' onSubmit={handleSubmit}>
                <div className="form-group">
                    <div className="row-input">
                        <img src="/images/mail.png" alt="" />
                        <input type="email" name="email" id="email" onChange={handleChange} required autoComplete="off" placeholder="Enter your email" />
                    </div>
                    {
                        error?.errors?.email?.map((error) => (
                            <ErrorMessage text={error} />
                        ))
                    }
                </div>
                <p className="para2">
                    <Link to="/login">
                        <i className="fa-solid fa-chevron-left me-2"></i>
                        {"Back to Login"}
                    </Link>
                </p>
                
                <button disabled={loader} type="submit" className={`btn_auth ${loader? "disabled-button" : ""} `}>
                    {loader ?
                        <>
                            <Spinner size="sm">
                                Loading...
                            </Spinner>

                            <span>
                                {' '}Loading
                            </span>
                        </>
                        :
                        <span>
                            Submit
                        </span>
                    }
                </button>
            </form>
        </AuthLayout>
    )

}

export default ForgotPassword;
